import { isServiceRoute, serviceTheme } from './serviceTheme'

// Element UI 的这些控件可能将面板移到 body，不能仅靠布局容器继承变量。
const OVERLAY_COMPONENTS = new Set([
  'ElDialog', 'ElDrawer', 'ElSelect', 'ElSelectDropdown', 'ElCascader',
  'ElDatePicker', 'ElTimePicker', 'ElTimeSelect', 'ElDropdownMenu',
  'ElPopover', 'ElTooltip', 'ElAutocomplete', 'ElAutocompleteSuggestions', 'ElMessageBox', 'ElLoading'
])

export function installServiceThemeOverlays(Vue, store, router) {
  const contexts = new WeakMap()
  const owners = new WeakMap()
  const routeOf = vm => vm.$route || (router.app && router.app.$route) || router.currentRoute
  function clear(context) {
    context.nodes.forEach(node => {
      const previous = owners.get(node)
      if (!previous) return
      previous.contexts.delete(context)
      if (previous.contexts.size) return
      previous.variables.forEach(([key, value, priority]) => {
        if (value) node.style.setProperty(key, value, priority)
        else node.style.removeProperty(key)
      })
      if (!previous.hadClass) node.classList.remove('service-theme')
      owners.delete(node)
    })
    context.nodes.clear()
  }
  function refresh(vm) {
    const context = contexts.get(vm)
    if (!context) return
    clear(context)
    if (vm._isDestroyed || vm._inactive || !isServiceRoute(routeOf(vm)) ||
        !store.getters['template/serviceThemeEnabled']) return
    const variables = serviceTheme(store.state.template.globalStyle).variables
    const refs = vm.$refs || {}
    const candidates = [vm.$el, vm.popperElm, refs.popper, refs.popover, refs.tooltip, refs.suggestions, vm.picker]
    candidates.forEach(candidate => {
      const node = candidate && (candidate.$el || candidate)
      if (!node || node.nodeType !== 1 || context.nodes.has(node)) return
      if (!owners.has(node)) {
        owners.set(node, {
          contexts: new Set(),
          hadClass: node.classList.contains('service-theme'),
          variables: Object.keys(variables).map(key => [key, node.style.getPropertyValue(key), node.style.getPropertyPriority(key)])
        })
      }
      owners.get(node).contexts.add(context)
      context.nodes.add(node)
      node.classList.add('service-theme')
      Object.keys(variables).forEach(key => node.style.setProperty(key, variables[key]))
    })
  }
  function schedule(vm) {
    const context = contexts.get(vm)
    if (!context || context.pending) return
    context.pending = true
    vm.$nextTick(() => {
      context.pending = false
      refresh(vm)
    })
  }
  Vue.mixin({
    mounted() {
      if (!OVERLAY_COMPONENTS.has(this.$options.name)) return
      const context = { nodes: new Set(), stops: [], pending: false }
      contexts.set(this, context)
      context.stops.push(this.$watch(() => store.state.template.globalStyle, () => schedule(this)))
      context.stops.push(this.$watch(() => store.state.template.frontendFeatures.serviceThemeEnabled, () => schedule(this)))
      context.stops.push(this.$watch(() => routeOf(this), () => schedule(this)))
      // 日期面板等在第一次打开时才创建；等待本轮渲染后给新面板传递变量。
      ;['visible', 'pickerVisible', 'showPopper'].forEach(key => {
        if (key in this) context.stops.push(this.$watch(key, () => schedule(this)))
      })
      schedule(this)
    },
    updated() { if (contexts.has(this)) schedule(this) },
    activated() { if (contexts.has(this)) schedule(this) },
    deactivated() { const context = contexts.get(this); if (context) clear(context) },
    beforeDestroy() {
      const context = contexts.get(this)
      if (!context) return
      context.stops.forEach(stop => stop())
      clear(context)
      contexts.delete(this)
    }
  })
}
